<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <div class="d-flex align-center mb-4">
      <DatePicker v-model="selectedDate" />
    </div>
    <v-data-table-server
      :items="pagos"
      :items-per-page="perPage"
      :items-length="totalPagos"
      :headers="headers"
      :page="page"
      :loading="loading"
      :item-value="id"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
      class="elevation-1"
      show-expand
      expand-on-click="false"
      :expanded="expanded"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-text-field
            v-model="pagosStore.search_query"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            @input="loadPagos"
          ></v-text-field> -->
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="newItem()"
            >Nuevo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        {{ showTipoPagoText(item.tipo) }}
      </template>
      <template v-slot:[`item.caja_fecha`]="{ item }">
        {{ formatDate(item.caja_fecha) }}
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        {{ formatCurrency(item.importe) }} €
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" color="green">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)" color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:expanded-row="{ item }">
        <tr
          v-if="item.detalle && item.detalle.trim() !== ''"
          class="expanded-detalle"
        >
          <td :colspan="headers.length">
            <div class="pa-4">{{ item.detalle }}</div>
          </td>
        </tr>
      </template>
    </v-data-table-server>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { usePagosStore } from '@/stores/pagosStore'
import { useCajaStore } from '@/stores/cajaStore'
import {
  formatCurrency,
  formatDate,
  showTipoPagoText,
  userIsRecepcion
} from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'
import DatePicker from '@/components/common/DatePicker.vue'
import { useRoute } from 'vue-router'
import { SELECT_PAGOS } from '@/utils/constants'

const pagosStore = usePagosStore()
const { pagos, totalPagos, page, perPage } = storeToRefs(pagosStore)
const loading = ref(false)
const cajaStore = useCajaStore()
const selectedDate = ref(null)
const cajaReady = inject('cajaReady', ref(true)) // Default to true if not provided

const emit = defineEmits(['editItem', 'delete', 'newItem'])
const expanded = ref([])

const route = useRoute()
const routeSegment = route.path.split('/').pop().toUpperCase()

let headers = []
if (routeSegment === 'C') {
  headers = [
    { title: 'Fecha', key: 'caja_fecha', align: 'center' },
    { title: 'Turno', key: 'turno', align: 'center' },
    { title: 'Usuario', key: 'usuario_iniciales', align: 'center' },
    { title: 'Tipo', key: 'tipo', align: 'center' },
    {
      title: 'Registro',
      key: 'registro',
      align: 'center'
    },
    { title: 'Factura', key: 'factura_localizador', align: 'end' },
    { title: 'Importe', key: 'importe', align: 'end' },
    { title: '', key: 'data-table-expand' },
    {
      title: '  ',
      width: '100px',
      key: 'actions',
      sortable: false
    }
  ]
}

if (routeSegment === 'E') {
  headers = [
    { title: 'Fecha', key: 'caja_fecha', align: 'center' },
    { title: 'Turno', key: 'turno', align: 'center' },
    { title: 'Usuario', key: 'usuario_iniciales', align: 'center' },
    { title: 'Tipo', key: 'tipo', align: 'center' },
    { title: 'Factura', key: 'factura_localizador', align: 'end' },
    { title: 'Importe', key: 'importe', align: 'end' },
    { title: '', key: 'data-table-expand' },
    {
      title: '  ',
      width: '100px',
      key: 'actions',
      sortable: false
    }
  ]
}
if (routeSegment === 'F') {
  headers = [
    { title: 'Fecha', key: 'caja_fecha', align: 'center' },
    { title: 'Turno', key: 'turno', align: 'center' },
    { title: 'Usuario', key: 'usuario_iniciales', align: 'center' },
    { title: 'Tipo', key: 'tipo', align: 'center' },
    {
      title: 'Registro',
      key: 'registro',
      align: 'center'
    },
    { title: 'Localizador', key: 'factura_localizador', align: 'end' },
    { title: 'Importe', key: 'importe', align: 'end' },
    { title: '', key: 'data-table-expand' },
    {
      title: '  ',
      width: '100px',
      key: 'actions',
      sortable: false
    }
  ]
}
if (routeSegment === 'H') {
  headers = [
    { title: 'Fecha', key: 'caja_fecha', align: 'center' },
    { title: 'Turno', key: 'turno', align: 'center' },
    { title: 'Usuario', key: 'usuario_iniciales', align: 'center' },
    { title: 'Tipo', key: 'tipo', align: 'center' },
    {
      title: 'Registro',
      key: 'registro',
      align: 'center'
    },
    { title: 'Importe', key: 'importe', align: 'end' },
    { title: '', key: 'data-table-expand' },
    {
      title: '  ',
      width: '100px',
      key: 'actions',
      sortable: false
    }
  ]
}

onMounted(async () => {
  // Wait for cajaReady to be true before loading data
  if (cajaReady.value) {
    initializeData()
  } else {
    // Watch for changes in cajaReady
    const unwatch = watch(cajaReady, (newValue) => {
      if (newValue === true) {
        initializeData()
        unwatch() // Stop watching once initialized
      }
    })
  }
})

const initializeData = () => {
  nextTick(async () => {
    const fecha = cajaStore.lastCaja?.fecha || new Date()
    console.log('Pasa por aquí onMounted', cajaStore.lastCaja.fecha, fecha)
    if (fecha instanceof Date) {
      const year = fecha.getFullYear()
      const month = String(fecha.getMonth() + 1).padStart(2, '0')
      const day = String(fecha.getDate()).padStart(2, '0')
      selectedDate.value = `${year}-${month}-${day}`
    } else {
      selectedDate.value = fecha
    }
    // await loadPagos()
  })
}

// Observar cambios en la fecha seleccionada
watch(selectedDate, () => {
  loadPagos()
})

const loadPagos = async () => {
  const filteredValues = SELECT_PAGOS.filter(
    (item) => item.type === routeSegment
  ).map((item) => item.value)

  let fecha = selectedDate.value || null

  console.log('Pasa por aquí', fecha, filteredValues)
  await pagosStore.fetchPagos({ search: filteredValues, fecha: fecha })
}

const onPageChange = (newPage) => {
  pagosStore.setPage(newPage)
  loadPagos()
}

const onItemsPerPageChange = (newItemsPerPage) => {
  perPage.value = newItemsPerPage
  pagosStore.setRows(newItemsPerPage)
  loadPagos()
}

const deleteItem = (item) => {
  emit('delete', item.id)
}

const editItem = (item) => {
  emit('editItem', item)
}

const newItem = () => {
  emit('newItem')
}
</script>
